// @flow
import * as React from 'react';
import { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import TitledCard from 'common/components/cards/TitledCard';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import FileUploadButton from './FileUploadButton';
import { Label, RowWrapper } from '../../styles';
import type { StatsRadioPlayerThemeData } from '../../../domain/PlayerConfiguration';
import BannerDemo from './demos/BannerDemo';

type Props = {
  data: StatsRadioPlayerThemeData;
  onBannerChanged: (banner: any, display: boolean) => any;
  t: any;
  theme: Object;
}


function Banner(props: Props) {
  return (
    <TitledCard title={props.t('banner')}>
      <div className="row">
        <div className="col-xs-6">
          <Label withPadding>{props.t('doYouWantABannerWithImage')}</Label>
          <RadioButtonGroup
            name="doYouWantABannerWithImage"
            onChange={(e, v) => props.onBannerChanged(props.data.backgroundImage, !v)}
            defaultSelected={!props.data.hideBanner}
          >
            <RadioButton
              value
              label={props.t('yes')}
            />
            <RadioButton
              value={false}
              label={props.t('no')}
            />
          </RadioButtonGroup>
        </div>
        <div className="col-xs-6">
          { !props.data.hideBanner &&
            <BannerDemo
              data={props.data}
            />
          }
        </div>
      </div>
      <RowWrapper className="row" hidden={props.data.hideBanner}>
        <div className="col-xs-6">
          <Label>{props.t('bannerImage')}</Label>
          <FileUploadButton
            onUpload={bannerImageFile => props.onBannerChanged(bannerImageFile, props.data.hideBanner)}
            label={props.t('add')}
          />
        </div>
      </RowWrapper>
    </TitledCard>
  );
}

export default withTheme(translate('radioConfiguration')(Banner));



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/playerConfigurationForm/statsRadioPlayer/Banner.js